import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import "../Components/UserSignIn/SignIn.css";
import { useDispatch } from "react-redux";
import {
  LOGIN_SUCCESS,
} from "../Constants/userConstants.js";
import { useParams } from 'react-router-dom';

const OtpVerification = () => {
  const [otp, setOtp] = useState('');
  const [message, setMessage] = useState('');
  // const location = useLocation();
  const navigate = useNavigate();

  const params = useParams();

  // const userId = location.state?.userId || localStorage.getItem('userId');
  const userId = params.uid;
  const dispatch = useDispatch();

  if (!userId) {
    navigate('/login');
    return null;
  }

  const handleChange = (event) => {
    setOtp(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post('/api/v1/users/verifyOtp', { userId, otp });
      console.log('Server response:', response.data);

      if (response.data.user){
        setMessage('Passcode verified successfully!');
        dispatch({ type: LOGIN_SUCCESS, payload: response.data.user });
        navigate('/'); 
      } else {
        setMessage("Login Error");
      }
    } catch (error) {
      console.error('Error verifying passcode:', error.response || error.message);
      const errorMessage = error.response?.data?.message || 'Invalid or expired OTP';
      setMessage(errorMessage);
    }
  };

  const handleResend = async () => {
    try {
      await axios.post('/api/v1/users/resendOtp', { userId });
      setMessage('A new passcode has been resent to your email.');
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to resend OTP.';
      setMessage(errorMessage);
    }
  };

  // localStorage.setItem('userId', userId);


  return (
    <div className="sign-in">
      <h1>Two-Factor Authentication</h1>
      <p>A 6-digit login code has been sent to your email.</p>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Verification Code:</label>
          <input type="text" value={otp} onChange={handleChange} maxLength="6" required />
        </div>
        {message && <div className="message">{message}</div>}
        <button className="login-button" type="submit">Verify</button>
      </form>
      <div className="register-link">
        {/* eslint-disable-next-line */}
        <a href="#" onClick={handleResend}>Resend Passcode</a>
      </div>
    </div>
  );
};

export default OtpVerification;
